import * as palette from '@mlc/mlc-palette';
import { FieldWrapper } from '@mlc/web-ui-toolkit';
import styled from 'styled-components';
import { ScreenSize, FontFamily } from '../../../../enums';
import Config from '../../../../AppConfig';

export const LoadingWrapper = styled.div`
	position: absolute;
	right: 0;
	top: 10px;
`;

const searchWhiteImg = `${Config.aemImageEnv}online/resource/images/Search_white.png`;

export const SearchButton = styled.button`
	background: ${palette.mlcOrange};
	border: none;
	color: ${palette.mlcWhite};
	font-family: ${FontFamily.charlieBold};
	font-size: 18px;
	height: 44px;
	margin: 0;
	padding: 0;
	vertical-align: middle;
	width: 133px;

	&:focus,
	&:hover {
		cursor: pointer;
		text-decoration: underline;
	}

	@media (max-width: ${ScreenSize.xSmall}) {
		background-image: url(${(p: { buttonImage: string }) => p.buttonImage});
		background-position: center center;
		background-repeat: no-repeat;
		padding: 0 25px !important;
		text-indent: -9999px;
		width: auto;
	}
`;

export const SearchIcon = styled.span`
	margin-left: 5px;
`;

export const SearchForm = styled.form`
	display: flex;
	flex: 1;
	flex-direction: row;
`;

export const SearchWrapper = styled(FieldWrapper)`
	flex-grow: 1;
`;
